import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, vShow as _vShow, vModelCheckbox as _vModelCheckbox } from "vue";
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" };
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" };
const _hoisted_3 = { class: "d-sm-flex align-items-center" };
const _hoisted_4 = { class: "d-flex align-items-center" };
const _hoisted_5 = ["placeholder"];
const _hoisted_6 = { class: "card-body p-15 p-sm-20 p-md-25" };
const _hoisted_7 = { class: "table-responsive" };
const _hoisted_8 = { class: "table text-nowrap align-middle mb-0" };
const _hoisted_9 = { key: 0 };
const _hoisted_10 = {
    colspan: "5",
    class: "text-center py-4"
};
const _hoisted_11 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" };
const _hoisted_12 = { class: "d-flex align-items-center" };
const _hoisted_13 = ["src"];
const _hoisted_14 = {
    key: 1,
    class: "rounded-circle bg-light d-flex align-items-center justify-content-center me-10",
    width: "35",
    height: "35"
};
const _hoisted_15 = { class: "shadow-none lh-1 fw-medium text-warning" };
const _hoisted_16 = {
    class: "shadow-none lh-1 fw-medium text-muted text-wrap",
    style: { "max-width": "400px" }
};
const _hoisted_17 = { class: "form-check form-switch" };
const _hoisted_18 = ["checked", "onChange"];
const _hoisted_19 = { class: "shadow-none lh-1 fw-medium text-end pe-0" };
const _hoisted_20 = { class: "dropdown" };
const _hoisted_21 = { class: "dropdown-menu" };
const _hoisted_22 = ["onClick"];
const _hoisted_23 = ["onClick"];
const _hoisted_24 = { key: 2 };
const _hoisted_25 = {
    class: "modal fade",
    id: "reviewModal",
    tabindex: "-1",
    "aria-hidden": "true"
};
const _hoisted_26 = { class: "modal-dialog modal-dialog-centered modal-lg" };
const _hoisted_27 = { class: "modal-content border-0 rounded-1" };
const _hoisted_28 = { class: "modal-header" };
const _hoisted_29 = { class: "modal-title fw-bold" };
const _hoisted_30 = { class: "modal-body p-20" };
const _hoisted_31 = { class: "row g-3" };
const _hoisted_32 = { class: "col-md-8" };
const _hoisted_33 = { class: "col-md-4" };
const _hoisted_34 = ["value"];
const _hoisted_35 = { class: "col-12 mt-4" };
const _hoisted_36 = { class: "col-12 mt-4" };
const _hoisted_37 = {
    class: "nav nav-tabs mb-3 border-0 bg-light p-1 rounded-1",
    role: "tablist"
};
const _hoisted_38 = ["onClick"];
const _hoisted_39 = { class: "form-label fw-semibold" };
const _hoisted_40 = ["onUpdate:modelValue", "required"];
const _hoisted_41 = { class: "col-12 border-top mt-4 pt-3" };
const _hoisted_42 = { class: "form-check form-switch mb-2" };
const _hoisted_43 = { class: "text-end mt-4" };
const _hoisted_44 = ["disabled"];
const _hoisted_45 = {
    key: 0,
    class: "fas fa-spinner fa-spin me-2"
};
const _hoisted_46 = {
    class: "modal fade",
    id: "deleteConfirmModal",
    tabindex: "-1",
    "aria-hidden": "true"
};
const _hoisted_47 = { class: "modal-dialog modal-dialog-centered" };
const _hoisted_48 = { class: "modal-content border-0 rounded-1" };
const _hoisted_49 = { class: "modal-body p-20" };
const _hoisted_50 = {
    key: 0,
    class: "alert alert-warning py-2 small"
};
const _hoisted_51 = { class: "modal-footer border-0" };
const _hoisted_52 = ["disabled"];
const _hoisted_53 = {
    key: 0,
    class: "fas fa-spinner fa-spin me-2"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_LoaderComponent = _resolveComponent("LoaderComponent");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("button", {
                    onClick: _cache[0] || (_cache[0] =
                        //@ts-ignore
                        (...args) => (_ctx.openAddModal && _ctx.openAddModal(...args))),
                    class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0",
                    type: "button"
                }, [
                    _createTextVNode(_toDisplayString(_ctx.$t('common.add')) + " Témoignage ", 1),
                    _cache[9] || (_cache[9] = _createElementVNode("i", { class: "flaticon-plus position-relative ms-5 fs-12" }, null, -1))
                ])
            ]),
            _createElementVNode("div", _hoisted_4, [
                _createElementVNode("form", {
                    class: "search-box position-relative me-15",
                    onSubmit: _cache[2] || (_cache[2] = _withModifiers(() => { }, ["prevent"]))
                }, [
                    _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.searchQuery) = $event)),
                        type: "text",
                        class: "form-control shadow-none text-black rounded-0 border-0",
                        placeholder: _ctx.$t('common.search')
                    }, null, 8, _hoisted_5), [
                        [_vModelText, _ctx.searchQuery]
                    ]),
                    _cache[10] || (_cache[10] = _createElementVNode("button", {
                        type: "submit",
                        class: "bg-transparent text-primary transition p-0 border-0"
                    }, [
                        _createElementVNode("i", { class: "flaticon-search-interface-symbol" })
                    ], -1))
                ], 32)
            ])
        ]),
        _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
                _createElementVNode("table", _hoisted_8, [
                    _cache[16] || (_cache[16] = _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                            _createElementVNode("th", {
                                scope: "col",
                                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                            }, "Auteur"),
                            _createElementVNode("th", {
                                scope: "col",
                                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                            }, "Note"),
                            _createElementVNode("th", {
                                scope: "col",
                                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                            }, "Commentaire (FR)"),
                            _createElementVNode("th", {
                                scope: "col",
                                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                            }, "Statut"),
                            _createElementVNode("th", {
                                scope: "col",
                                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end"
                            }, "Actions")
                        ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                        (_ctx.isLoading)
                            ? (_openBlock(), _createElementBlock("tr", _hoisted_9, [
                                _createElementVNode("td", _hoisted_10, [
                                    _createVNode(_component_LoaderComponent)
                                ])
                            ]))
                            : (_ctx.filteredReviews.length > 0)
                                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.filteredReviews, (review) => {
                                    return (_openBlock(), _createElementBlock("tr", {
                                        key: review.id
                                    }, [
                                        _createElementVNode("td", _hoisted_11, [
                                            _createElementVNode("div", _hoisted_12, [
                                                (review.avatarUrl)
                                                    ? (_openBlock(), _createElementBlock("img", {
                                                        key: 0,
                                                        src: review.avatarUrl,
                                                        class: "rounded-circle me-10",
                                                        width: "35",
                                                        height: "35",
                                                        alt: "avatar"
                                                    }, null, 8, _hoisted_13))
                                                    : (_openBlock(), _createElementBlock("div", _hoisted_14, [...(_cache[11] || (_cache[11] = [
                                                            _createElementVNode("i", { class: "fas fa-user text-muted" }, null, -1)
                                                        ]))])),
                                                _createTextVNode(" " + _toDisplayString(review.author), 1)
                                            ])
                                        ]),
                                        _createElementVNode("td", _hoisted_15, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(review.rating, (i) => {
                                                return (_openBlock(), _createElementBlock("i", {
                                                    class: "fas fa-star",
                                                    key: i
                                                }));
                                            }), 128))
                                        ]),
                                        _createElementVNode("td", _hoisted_16, _toDisplayString(_ctx.truncateText(_ctx.getTranslatedContent(review.comment), 100)), 1),
                                        _createElementVNode("td", null, [
                                            _createElementVNode("div", _hoisted_17, [
                                                _createElementVNode("input", {
                                                    class: "form-check-input",
                                                    type: "checkbox",
                                                    checked: review.isActive,
                                                    onChange: ($event) => (_ctx.toggleStatus(review))
                                                }, null, 40, _hoisted_18)
                                            ])
                                        ]),
                                        _createElementVNode("td", _hoisted_19, [
                                            _createElementVNode("div", _hoisted_20, [
                                                _cache[14] || (_cache[14] = _createElementVNode("button", {
                                                    class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
                                                    type: "button",
                                                    "data-bs-toggle": "dropdown"
                                                }, [
                                                    _createElementVNode("i", { class: "flaticon-dots" })
                                                ], -1)),
                                                _createElementVNode("ul", _hoisted_21, [
                                                    _createElementVNode("li", null, [
                                                        _createElementVNode("a", {
                                                            class: "dropdown-item d-flex align-items-center",
                                                            href: "javascript:void(0);",
                                                            onClick: ($event) => (_ctx.editReview(review))
                                                        }, [...(_cache[12] || (_cache[12] = [
                                                                _createElementVNode("i", { class: "flaticon-pen lh-1 me-8" }, null, -1),
                                                                _createTextVNode(" Modifier ", -1)
                                                            ]))], 8, _hoisted_22)
                                                    ]),
                                                    _createElementVNode("li", null, [
                                                        _createElementVNode("a", {
                                                            class: "dropdown-item d-flex align-items-center text-danger",
                                                            href: "javascript:void(0);",
                                                            onClick: ($event) => (_ctx.confirmDelete(review))
                                                        }, [...(_cache[13] || (_cache[13] = [
                                                                _createElementVNode("i", { class: "flaticon-delete lh-1 me-8" }, null, -1),
                                                                _createTextVNode(" Supprimer ", -1)
                                                            ]))], 8, _hoisted_23)
                                                    ])
                                                ])
                                            ])
                                        ])
                                    ]));
                                }), 128))
                                : (_openBlock(), _createElementBlock("tr", _hoisted_24, [...(_cache[15] || (_cache[15] = [
                                        _createElementVNode("td", {
                                            colspan: "5",
                                            class: "text-center py-4 text-muted"
                                        }, "Aucun témoignage trouvé.", -1)
                                    ]))]))
                    ])
                ])
            ])
        ]),
        _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("h5", _hoisted_29, _toDisplayString(_ctx.isEditing ? 'Modifier le témoignage' : 'Ajouter un témoignage'), 1),
                        _cache[17] || (_cache[17] = _createElementVNode("button", {
                            type: "button",
                            class: "btn-close shadow-none",
                            "data-bs-dismiss": "modal",
                            "aria-label": "Close"
                        }, null, -1))
                    ]),
                    _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("form", {
                            onSubmit: _cache[7] || (_cache[7] = _withModifiers(
                            //@ts-ignore
                            (...args) => (_ctx.saveReview && _ctx.saveReview(...args)), ["prevent"]))
                        }, [
                            _createElementVNode("div", _hoisted_31, [
                                _createElementVNode("div", _hoisted_32, [
                                    _cache[18] || (_cache[18] = _createElementVNode("label", { class: "form-label fw-semibold" }, "Nom de l'auteur", -1)),
                                    _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        class: "form-control shadow-none rounded-0 border-light-subtle",
                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.form.author) = $event)),
                                        required: ""
                                    }, null, 512), [
                                        [_vModelText, _ctx.form.author]
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_33, [
                                    _cache[19] || (_cache[19] = _createElementVNode("label", { class: "form-label fw-semibold" }, "Note (1-5)", -1)),
                                    _withDirectives(_createElementVNode("select", {
                                        class: "form-select shadow-none rounded-0 border-light-subtle",
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.form.rating) = $event))
                                    }, [
                                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (n) => {
                                            return _createElementVNode("option", {
                                                key: n,
                                                value: n
                                            }, _toDisplayString(n) + " Étoile" + _toDisplayString(n > 1 ? 's' : ''), 9, _hoisted_34);
                                        }), 64))
                                    ], 512), [
                                        [
                                            _vModelSelect,
                                            _ctx.form.rating,
                                            void 0,
                                            { number: true }
                                        ]
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_35, [
                                    _cache[20] || (_cache[20] = _createElementVNode("label", { class: "form-label fw-semibold" }, "Avatar / Image (URL)", -1)),
                                    _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        class: "form-control shadow-none rounded-0 border-light-subtle",
                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.form.avatarUrl) = $event)),
                                        placeholder: "https://..."
                                    }, null, 512), [
                                        [_vModelText, _ctx.form.avatarUrl]
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_36, [
                                    _createElementVNode("ul", _hoisted_37, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableLangs, (lang) => {
                                            return (_openBlock(), _createElementBlock("li", {
                                                class: "nav-item",
                                                key: lang.code
                                            }, [
                                                _createElementVNode("button", {
                                                    class: _normalizeClass(["nav-link border-0 text-uppercase fw-bold py-2 px-3 rounded-1 transition shadow-none", { 'active bg-white text-primary shadow-sm': _ctx.activeLocale === lang.code, 'text-muted': _ctx.activeLocale !== lang.code }]),
                                                    onClick: ($event) => (_ctx.activeLocale = lang.code),
                                                    type: "button"
                                                }, _toDisplayString(lang.label), 11, _hoisted_38)
                                            ]));
                                        }), 128))
                                    ]),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableLangs, (lang) => {
                                        return _withDirectives((_openBlock(), _createElementBlock("div", {
                                            key: 'c-' + lang.code
                                        }, [
                                            _createElementVNode("label", _hoisted_39, "Commentaire (" + _toDisplayString(lang.label) + ")", 1),
                                            _withDirectives(_createElementVNode("textarea", {
                                                class: "form-control shadow-none rounded-0 border-light-subtle",
                                                rows: "4",
                                                "onUpdate:modelValue": ($event) => ((_ctx.form.comment[lang.code]) = $event),
                                                required: lang.code === 'fr'
                                            }, null, 8, _hoisted_40), [
                                                [_vModelText, _ctx.form.comment[lang.code]]
                                            ])
                                        ])), [
                                            [_vShow, _ctx.activeLocale === lang.code]
                                        ]);
                                    }), 128))
                                ]),
                                _createElementVNode("div", _hoisted_41, [
                                    _createElementVNode("div", _hoisted_42, [
                                        _withDirectives(_createElementVNode("input", {
                                            class: "form-check-input ms-0",
                                            type: "checkbox",
                                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.form.isActive) = $event)),
                                            id: "modalActive"
                                        }, null, 512), [
                                            [_vModelCheckbox, _ctx.form.isActive]
                                        ]),
                                        _cache[21] || (_cache[21] = _createElementVNode("label", {
                                            class: "form-check-label ms-2",
                                            for: "modalActive"
                                        }, "Afficher sur le site", -1))
                                    ])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_43, [
                                _cache[23] || (_cache[23] = _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn-secondary me-2 rounded-0",
                                    "data-bs-dismiss": "modal"
                                }, "Annuler", -1)),
                                _createElementVNode("button", {
                                    type: "submit",
                                    class: "btn btn-primary rounded-0 px-4",
                                    disabled: _ctx.isSaving
                                }, [
                                    (_ctx.isSaving)
                                        ? (_openBlock(), _createElementBlock("i", _hoisted_45))
                                        : _createCommentVNode("", true),
                                    _cache[22] || (_cache[22] = _createTextVNode(" Enregistrer ", -1))
                                ], 8, _hoisted_44)
                            ])
                        ], 32)
                    ])
                ])
            ])
        ]),
        _createElementVNode("div", _hoisted_46, [
            _createElementVNode("div", _hoisted_47, [
                _createElementVNode("div", _hoisted_48, [
                    _cache[28] || (_cache[28] = _createElementVNode("div", { class: "modal-header" }, [
                        _createElementVNode("h5", { class: "modal-title fw-bold" }, "Confirmer la suppression"),
                        _createElementVNode("button", {
                            type: "button",
                            class: "btn-close shadow-none",
                            "data-bs-dismiss": "modal",
                            "aria-label": "Close"
                        })
                    ], -1)),
                    _createElementVNode("div", _hoisted_49, [
                        _cache[25] || (_cache[25] = _createElementVNode("p", null, "Voulez-vous vraiment supprimer ce témoignage ? Cette action est irréversible.", -1)),
                        (_ctx.reviewToDelete && !_ctx.reviewToDelete.id)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_50, [...(_cache[24] || (_cache[24] = [
                                    _createElementVNode("i", { class: "fas fa-exclamation-triangle me-2" }, null, -1),
                                    _createTextVNode(" Attention: Ce témoignage a un ID invalide (vide) et doit être supprimé manuellement en base de données par un développeur. ", -1)
                                ]))]))
                            : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_51, [
                        _cache[27] || (_cache[27] = _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-secondary rounded-0",
                            "data-bs-dismiss": "modal"
                        }, "Annuler", -1)),
                        _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-danger rounded-0 px-4",
                            onClick: _cache[8] || (_cache[8] =
                                //@ts-ignore
                                (...args) => (_ctx.executeDelete && _ctx.executeDelete(...args))),
                            disabled: _ctx.isDeleting || (_ctx.reviewToDelete && !_ctx.reviewToDelete.id)
                        }, [
                            (_ctx.isDeleting)
                                ? (_openBlock(), _createElementBlock("i", _hoisted_53))
                                : _createCommentVNode("", true),
                            _cache[26] || (_cache[26] = _createTextVNode(" Supprimer ", -1))
                        ], 8, _hoisted_52)
                    ])
                ])
            ])
        ])
    ]));
}
